import _ from 'lodash'
import { SERVERS_SET_PROFILES } from '../constants'
import { actionUsersSetUserProfile } from '../actions'

const UserProfileMiddleware = store => next => (action) => {
    switch (action.type) {
        case SERVERS_SET_PROFILES: {
            const result = next(action)
            try {
                const state = store.getState()
                const server = state.servers.list[action.payload.server]
                const users = state.users.list[action.payload.server]
                if (server != null && users != null) {
                    _.mapValues(users, ((user) => {
                        if (!_.includes(server.profiles, user.profile)) {
                            store.dispatch(actionUsersSetUserProfile(server.shortName, user.username, 'Default'))
                        }
                    }))
                }
            } catch (error) {
                console.error(`Couldn't update user profiles: ${error}`)
            }

            return result
        }

        default:
            return next(action)
    }
}

export default UserProfileMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/UserProfileMiddleware.js